import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  GridItem,
  Heading,
  Flex,
  Text,
  Stat,
  StatLabel,
  Button,
  StatNumber,
  Table,
  Tbody,
  Thead,
  Tr,
  Td,
  Select,
  Input,
} from "@chakra-ui/react";
import Chart from "./Chart";
import toast from "react-hot-toast";
import Donut from "./dountChart";
import axios from "axios";
import { FaRupeeSign } from "react-icons/fa";

const Dashboard = () => {
  const customerId = localStorage.getItem("customerId");
  const [totalSales,setTotalSales]=useState([]);
  const [discount,setDiscount]=useState([]);
  const [due,setDue]=useState([]);
  const [foodBill, setFoodBill] = useState([]);
  const [cash, setCash] = useState([]);
  const [online, setOnline] = useState([]);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `https://api.rcb.tdrsoftware.in/api/getQuickBillTodayData/${customerId}`
      );
      setFoodBill(response.data.totalSales);
      setDiscount(response.data.totalDiscount);
      setTotalSales(response.data.totalSales);
      setDue(response.data.due);
    } catch (error) {
      // toast.error(error.message);
    }
  };

  const cashData = async () => {
    try {
      const response = await axios.get(
        `https://api.rcb.tdrsoftware.in/api/getTodayCashData/${customerId}`
      );
      setCash(response.data.totalSales);
    } catch (error) {
      // toast.error(error.message);
    }
  };

  const onlineData = async () => {
    try {
      const response = await axios.get(
        `https://api.rcb.tdrsoftware.in/api/getTodayOnlineData/${customerId}`
      );
      setOnline(response.data.totalSales);
    } catch (error) {
      // toast.error(error.message);
    }
  };

  useEffect(() => {
    fetchData();
    cashData();
    onlineData();
  }, [customerId]);

  return (
    <Box p={{ base: 4, md: 6 }} bg="#e6cca3" minH="100vh" textAlign="center">
      <Text as="b" fontSize={{ base: "xl", md: "2xl" }} mb={6}>
        Admin Dashboard
      </Text>

      {/* Stats Cards */}
      <Flex
        direction={{ base: "column", md: "row" }}
        justify="space-around"
        align="center"
        gap={4}
        mt={6}
      >
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          bg="#0F172B"
          borderRadius="12px"
          p={4}
          w={{ base: "90%", md: "30%" }}
        >
          <Text fontSize="lg" color="white">
            Today's Sales
          </Text>
          <Text
            display="flex"
            alignItems="center"
            color="#FEA116"
            as="b"
            fontSize="xl"
          >
            <FaRupeeSign /> {totalSales}
          </Text>
        </Box>

        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          bg="#0F172B"
          borderRadius="12px"
          p={4}
          w={{ base: "90%", md: "30%" }}
        >
          <Text fontSize="lg" color="white">
            Today's Cash
          </Text>
          <Text
            display="flex"
            alignItems="center"
            color="#FEA116"
            as="b"
            fontSize="xl"
          >
            <FaRupeeSign /> {cash}
          </Text>
        </Box>

        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          bg="#0F172B"
          borderRadius="12px"
          p={4}
          w={{ base: "90%", md: "30%" }}
        >
          <Text fontSize="lg" color="white">
            Today's Online
          </Text>
          <Text
            display="flex"
            alignItems="center"
            color="#FEA116"
            as="b"
            fontSize="xl"
          >
            <FaRupeeSign /> {online}
          </Text>
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          bg="#0F172B"
          borderRadius="12px"
          p={4}
          w={{ base: "90%", md: "30%" }}
        >
          <Text fontSize="lg" color="white">
            Today's Discount
          </Text>
          <Text
            display="flex"
            alignItems="center"
            color="#FEA116"
            as="b"
            fontSize="xl"
          >
            <FaRupeeSign /> {discount}
          </Text>
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          bg="#0F172B"
          borderRadius="12px"
          p={4}
          w={{ base: "90%", md: "30%" }}
        >
          <Text fontSize="lg" color="white">
            Today's Due
          </Text>
          <Text
            display="flex"
            alignItems="center"
            color="#FEA116"
            as="b"
            fontSize="xl"
          >
            <FaRupeeSign /> {due}
          </Text>
        </Box>
      </Flex>

      {/* Charts Section */}
      <Grid
        templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }}
        gap={6}
        mt={10}
      >
        <GridItem bg="#EAE5DF" p={2} borderRadius={6} overflowX="auto">
          <Chart />
          <Flex align="center" justify="center">
            <Stat>
              <StatLabel>Food Bills</StatLabel>
            </Stat>
          </Flex>
        </GridItem>

        <GridItem bg="#EAE5DF" p={2} borderRadius={6}>
          <Donut />
          <Flex align="center" justify="center">
            <Stat>
              <StatLabel>Total Bills</StatLabel>
            </Stat>
          </Flex>
        </GridItem>
      </Grid>
    </Box>
  );
};

export default Dashboard;
